
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { MessagingProvider } from "./contexts/MessagingContext";
import { WishlistProvider } from "./app/context/WishlistContext.tsx";
import App from "./app/App.tsx";
import "./styles/index.css";
import './i18n';

 createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <MessagingProvider>
       <WishlistProvider>
      <App />
      </WishlistProvider>
    </MessagingProvider>
  </HelmetProvider>
);
  
